import React from 'react';
import { StatusCards, StatusContainer, StatusContentCards, StatusTitleCards } from "./DataCards.styled";

const DataCards = ({ options }) => {
  return (
    <StatusContainer>
      {options && options.map((state) => {
        return (
          <StatusCards key={state.name}>
            <StatusTitleCards>
              {state.name}
            </StatusTitleCards>
            <StatusContentCards> {state.value} </StatusContentCards>
          </StatusCards>
        );
      })}
    </StatusContainer>
  );
}

export default DataCards;